import React from 'react';
import { getEditorPreloader } from '@confluence-classic/confluence-fabric-editor/src/lib';

import type { RouteMatch } from '@confluence/route';
import { CONTAINER_HOME_ID } from '@confluence/app-navigation/entry-points/navigationIDs';
import { START_TOUCH } from '@confluence/navdex';
import { SpaceBlogsLoader } from '@confluence/space-blogs';
import { useBooleanFeatureFlag } from '@confluence/session-data';

import SpaceBase from '../../SpaceBase';

export const SpaceBlogsRoute = () => {
	const isSpaceAliasFFEnabled = useBooleanFeatureFlag('confluence.frontend.space.alias');
	if (isSpaceAliasFFEnabled) {
		return (
			<SpaceBase>
				<SpaceBlogsLoader />
			</SpaceBase>
		);
	} else {
		return <SpaceBlogsLoader />;
	}
};

SpaceBlogsRoute.NAVIGATION_PARAMS = ({ params: { spaceKey } }: RouteMatch) => ({
	Screen: {
		screenEvent: {
			name: 'spaceBlogsScreen',
			id: spaceKey,
			attributes: {
				containerId: spaceKey,
				navigationLayer: 'container',
				navdexPointType: START_TOUCH,
			},
		},
		pageState: { spaceKey },
	},
	MainLayout: {
		navView: CONTAINER_HOME_ID,
		spaceKey,
		editorPreloader: getEditorPreloader,
		disableMinWidth: true,
	},
});
